import React, { useState } from 'react';
import './CalendarView.css';

const CalendarView = ({ holidays = [], leaves = [] }) => {
    const [currentDate, setCurrentDate] = useState(new Date());

    const daysInMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };

    const firstDayOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    };

    const prevMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
    };

    const nextMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
    };

    const getDayHolidays = (day) => {
        return holidays.filter(h => {
            const hDate = new Date(h.date);
            return hDate.getDate() === day &&
                hDate.getMonth() === currentDate.getMonth() &&
                hDate.getFullYear() === currentDate.getFullYear();
        });
    };

    const getDayLeaves = (day) => {
        return leaves.filter(l => {
            if (l.status !== 'approved') return false;
            const lStart = new Date(l.startDate);
            const lEnd = new Date(l.endDate);
            const current = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
            const currentZero = new Date(current.getFullYear(), current.getMonth(), current.getDate()).getTime();
            const startZero = new Date(lStart.getFullYear(), lStart.getMonth(), lStart.getDate()).getTime();
            const endZero = new Date(lEnd.getFullYear(), lEnd.getMonth(), lEnd.getDate()).getTime();
            return currentZero >= startZero && currentZero <= endZero;
        });
    };

    const renderCalendarDays = () => {
        const totalDays = daysInMonth(currentDate);
        const startDay = firstDayOfMonth(currentDate);
        const days = [];

        // Empty cells for days before start of month
        for (let i = 0; i < startDay; i++) {
            days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }

        // Days of the month
        for (let i = 1; i <= totalDays; i++) {
            const currentDayDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
            const isToday = new Date().toDateString() === currentDayDate.toDateString();
            const dayOfWeek = currentDayDate.getDay(); // 0 is Sunday
            const dayHolidays = getDayHolidays(i);
            const dayLeaves = getDayLeaves(i);

            let title = '';
            let classes = ['calendar-day'];
            if (isToday) classes.push('today');

            if (dayHolidays.length > 0) {
                const activeHolidays = dayHolidays.filter(h => h.status !== 'withdrawn');
                const withdrawnHolidays = dayHolidays.filter(h => h.status === 'withdrawn');

                if (activeHolidays.length > 0) {
                    classes.push('has-holiday');
                    title = activeHolidays.map(h => h.name).join(', ');
                } else if (withdrawnHolidays.length > 0) {
                    classes.push('has-holiday-withdrawn');
                    title = withdrawnHolidays.map(h => `${h.name} (Withdrawn: ${h.withdrawnReason})`).join(', ');
                }
            } else if (dayLeaves.length > 0) {
                classes.push('has-leave');
                title = 'Leave';
            } else if (dayOfWeek === 0) {
                classes.push('is-sunday');
                title = 'Sunday';
            }

            days.push(
                <div key={i} className={classes.join(' ')} data-title={title}>
                    {i}
                </div>
            );
        }

        return days;
    };

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    return (
        <div className="calendar-container">
            <div className="calendar-header">
                <button onClick={prevMonth}>&lt;</button>
                <div className="calendar-selectors">
                    <select 
                        value={currentDate.getMonth()} 
                        onChange={(e) => setCurrentDate(new Date(currentDate.getFullYear(), parseInt(e.target.value), 1))}
                        className="calendar-select"
                    >
                        {monthNames.map((m, idx) => <option key={idx} value={idx}>{m}</option>)}
                    </select>
                    <select 
                        value={currentDate.getFullYear()} 
                        onChange={(e) => setCurrentDate(new Date(parseInt(e.target.value), currentDate.getMonth(), 1))}
                        className="calendar-select"
                    >
                        {Array.from({length: 11}, (_, i) => new Date().getFullYear() - 5 + i).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                </div>
                <button onClick={nextMonth}>&gt;</button>
            </div>
            <div className="calendar-grid">
                <div className="weekday">Sun</div>
                <div className="weekday">Mon</div>
                <div className="weekday">Tue</div>
                <div className="weekday">Wed</div>
                <div className="weekday">Thu</div>
                <div className="weekday">Fri</div>
                <div className="weekday">Sat</div>
                {renderCalendarDays()}
            </div>
        </div>
    );
};

export default CalendarView;
